module.exports = "/_next/static/images/demandResponse-19a8cb6fcb3a0ffb7210ca97ceff2e3f.png.webp";